export const isAddress = (address) => /^0x[a-fA-F0-9]{40}$/.test(`${address}`)
export const isSameAddress = (a, b) => {
  if (!isAddress(a)) return false
  if (!isAddress(b)) return false
  return `${a}`.toLowerCase() === `${b}`.toLowerCase()
}
export const containsIPFSCID = (str) => /Qm[a-zA-Z1-9]{44}/.test(`${str}`)
export const isDigits = (str) => /^\d+$/.test(`${str}`)
export const isURL = (str) =>
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(
    `${str}`
  )
